import { QueryResult, useQuery } from '@apollo/client'
import { ObjectivesWithAttachmentsFromMeetingQuery, ObjectivesWithAttachmentsFromMeetingQueryVariables } from '../../types'
import { OBJECTIVES_WITH_ATTACHMENTS_FROM_MEETING } from './ObjectiveQuery'

export const useObjectivesWithAttachmentsFromMeeting = (
  meetingId: number,
): QueryResult<ObjectivesWithAttachmentsFromMeetingQuery, ObjectivesWithAttachmentsFromMeetingQueryVariables> => {
  return useQuery<ObjectivesWithAttachmentsFromMeetingQuery, ObjectivesWithAttachmentsFromMeetingQueryVariables>(
    OBJECTIVES_WITH_ATTACHMENTS_FROM_MEETING,
    {
      variables: { meetingId },
    },
  )
}
